module.exports = __webpack_public_path__ + "img/social_media_tencent.dbdaa628.png";